import { render } from "./SelectTokenModal.vue?vue&type=template&id=dad8f906"
import script from "./SelectTokenModal.vue?vue&type=script&lang=ts"
export * from "./SelectTokenModal.vue?vue&type=script&lang=ts"
script.render = render

export default script